type StateToZipCodeRanges = {
  [key: string]: {
    min: number;
    max: number;
  }[];
};

export const stateToZipCodeRanges: StateToZipCodeRanges = {
  Alabama: [{ min: 35000, max: 36999 }],
  Alaska: [{ min: 99500, max: 99999 }],
  Arizona: [{ min: 85000, max: 86599 }],
  Arkansas: [{ min: 71600, max: 72999 }, { min: 75502, max: 75502 }],
  California: [{ min: 90000, max: 96199 }],
  Colorado: [{ min: 80000, max: 81699 }],
  Connecticut: [{ min: 6000, max: 6999 }],
  Delaware: [{ min: 19700, max: 19999 }],
  'District of Columbia': [{ min: 20000, max: 20599 }, { min: 56900, max: 56999 }, { min: 20799, max: 20799 }],
  Florida: [{ min: 32000, max: 34999 }],
  Georgia: [{ min: 30000, max: 31999 }, { min: 39800, max: 39999 }],
  Hawaii: [{ min: 96700, max: 96899 }],
  Idaho: [{ min: 83200, max: 83899 }],
  Illinois: [{ min: 60000, max: 62999 }],
  Indiana: [{ min: 46000, max: 47999 }],
  Iowa: [{ min: 50000, max: 52899 }, { min: 68119, max: 68120 }],
  Kansas: [{ min: 66000, max: 67999 }],
  Kentucky: [{ min: 40000, max: 42799 }],
  Louisiana: [{ min: 70000, max: 71499 }],
  Maine: [{ min: 3900, max: 4999 }],
  Maryland: [{ min: 20300, max: 21999 }],
  Massachusetts: [{ min: 1000, max: 2799 }, { min: 5500, max: 5599 }],
  Michigan: [{ min: 48000, max: 49999 }],
  Minnesota: [{ min: 55000, max: 56799 }],
  Mississippi: [{ min: 38600, max: 39799 }, { min: 71233, max: 71233 }],
  Missouri: [{ min: 63000, max: 65899 }],
  Montana: [{ min: 59000, max: 59999 }],
  Nebraska: [{ min: 68000, max: 69399 }],
  Nevada: [{ min: 88900, max: 89899 }],
  'New Hampshire': [{ min: 3000, max: 3899 }],
  'New Jersey': [{ min: 7000, max: 8999 }],
  'New Mexico': [{ min: 87000, max: 88499 }],
  'New York': [{ min: 500, max: 599 }, { min: 10000, max: 14999 }, { min: 6390, max: 6390 }],
  'North Carolina': [{ min: 27000, max: 28999 }],
  'North Dakota': [{ min: 58000, max: 58899 }],
  Ohio: [{ min: 43000, max: 45999 }],
  Oklahoma: [{ min: 73000, max: 73199 }, { min: 73400, max: 74999 }],
  Oregon: [{ min: 97000, max: 97999 }],
  Pennsylvania: [{ min: 15000, max: 19699 }],
  'Puerto Rico': [{ min: 600, max: 799 }, { min: 900, max: 999 }],
  'Rhode Island': [{ min: 2800, max: 2999 }],
  'South Carolina': [{ min: 29000, max: 29999 }],
  'South Dakota': [{ min: 57000, max: 57799 }],
  Tennessee: [{ min: 37000, max: 38599 }],
  Texas: [{ min: 73300, max: 73399 }, { min: 75000, max: 79999 }, { min: 88500, max: 88599 }],
  Utah: [{ min: 84000, max: 84799 }],
  Vermont: [{ min: 5000, max: 5499 }, { min: 5600, max: 5999 }],
  Virginia: [{ min: 20000, max: 20199 }, { min: 22000, max: 24699 }],
  Washington: [{ min: 98000, max: 99499 }],
  'West Virginia': [{ min: 24700, max: 26899 }],
  Wisconsin: [{ min: 53000, max: 54999 }],
  Wyoming: [{ min: 82000, max: 83199 }],
};

export function validateStateWithZipCode(state: string, zipCode: string): boolean {
  const zipCodeRanges = stateToZipCodeRanges[state];
  const zipCodeNum = zipCode ? parseInt(zipCode.substring(0, 5), 10) : 0;
  if (zipCodeRanges && zipCodeNum) {
    return zipCodeRanges.some(range => range.min <= zipCodeNum && zipCodeNum <= range.max);
  }
  return false;
}

export const US_STATES = Object.keys(stateToZipCodeRanges);
